/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AttachmentsArrayResponseV3 } from '../models/attachments-array-response-v-3';
import { BinaryFileType } from '../models/binary-file-type';
import { getCarrierDiscrepancyReceiptAttachmentV3$Heic } from '../fn/receipts/get-carrier-discrepancy-receipt-attachment-v-3-heic';
import { GetCarrierDiscrepancyReceiptAttachmentV3$Heic$Params } from '../fn/receipts/get-carrier-discrepancy-receipt-attachment-v-3-heic';
import { getCarrierDiscrepancyReceiptAttachmentV3$Heif } from '../fn/receipts/get-carrier-discrepancy-receipt-attachment-v-3-heif';
import { GetCarrierDiscrepancyReceiptAttachmentV3$Heif$Params } from '../fn/receipts/get-carrier-discrepancy-receipt-attachment-v-3-heif';
import { getCarrierDiscrepancyReceiptAttachmentV3$Jpeg } from '../fn/receipts/get-carrier-discrepancy-receipt-attachment-v-3-jpeg';
import { GetCarrierDiscrepancyReceiptAttachmentV3$Jpeg$Params } from '../fn/receipts/get-carrier-discrepancy-receipt-attachment-v-3-jpeg';
import { getCarrierDiscrepancyReceiptAttachmentV3$Pdf } from '../fn/receipts/get-carrier-discrepancy-receipt-attachment-v-3-pdf';
import { GetCarrierDiscrepancyReceiptAttachmentV3$Pdf$Params } from '../fn/receipts/get-carrier-discrepancy-receipt-attachment-v-3-pdf';
import { getCarrierDiscrepancyReceiptAttachmentV3$Png } from '../fn/receipts/get-carrier-discrepancy-receipt-attachment-v-3-png';
import { GetCarrierDiscrepancyReceiptAttachmentV3$Png$Params } from '../fn/receipts/get-carrier-discrepancy-receipt-attachment-v-3-png';
import { getCarrierReceiptsForDeliveryNoteV3 } from '../fn/receipts/get-carrier-receipts-for-delivery-note-v-3';
import { GetCarrierReceiptsForDeliveryNoteV3$Params } from '../fn/receipts/get-carrier-receipts-for-delivery-note-v-3';
import { getConsigneeDiscrepancyReceiptAttachmentV3$Heic } from '../fn/receipts/get-consignee-discrepancy-receipt-attachment-v-3-heic';
import { GetConsigneeDiscrepancyReceiptAttachmentV3$Heic$Params } from '../fn/receipts/get-consignee-discrepancy-receipt-attachment-v-3-heic';
import { getConsigneeDiscrepancyReceiptAttachmentV3$Heif } from '../fn/receipts/get-consignee-discrepancy-receipt-attachment-v-3-heif';
import { GetConsigneeDiscrepancyReceiptAttachmentV3$Heif$Params } from '../fn/receipts/get-consignee-discrepancy-receipt-attachment-v-3-heif';
import { getConsigneeDiscrepancyReceiptAttachmentV3$Jpeg } from '../fn/receipts/get-consignee-discrepancy-receipt-attachment-v-3-jpeg';
import { GetConsigneeDiscrepancyReceiptAttachmentV3$Jpeg$Params } from '../fn/receipts/get-consignee-discrepancy-receipt-attachment-v-3-jpeg';
import { getConsigneeDiscrepancyReceiptAttachmentV3$Pdf } from '../fn/receipts/get-consignee-discrepancy-receipt-attachment-v-3-pdf';
import { GetConsigneeDiscrepancyReceiptAttachmentV3$Pdf$Params } from '../fn/receipts/get-consignee-discrepancy-receipt-attachment-v-3-pdf';
import { getConsigneeDiscrepancyReceiptAttachmentV3$Png } from '../fn/receipts/get-consignee-discrepancy-receipt-attachment-v-3-png';
import { GetConsigneeDiscrepancyReceiptAttachmentV3$Png$Params } from '../fn/receipts/get-consignee-discrepancy-receipt-attachment-v-3-png';
import { getConsigneeReceiptsForDeliveryNoteV3 } from '../fn/receipts/get-consignee-receipts-for-delivery-note-v-3';
import { GetConsigneeReceiptsForDeliveryNoteV3$Params } from '../fn/receipts/get-consignee-receipts-for-delivery-note-v-3';
import { getConsignorDiscrepancyReceiptAttachmentV3$Heic } from '../fn/receipts/get-consignor-discrepancy-receipt-attachment-v-3-heic';
import { GetConsignorDiscrepancyReceiptAttachmentV3$Heic$Params } from '../fn/receipts/get-consignor-discrepancy-receipt-attachment-v-3-heic';
import { getConsignorDiscrepancyReceiptAttachmentV3$Heif } from '../fn/receipts/get-consignor-discrepancy-receipt-attachment-v-3-heif';
import { GetConsignorDiscrepancyReceiptAttachmentV3$Heif$Params } from '../fn/receipts/get-consignor-discrepancy-receipt-attachment-v-3-heif';
import { getConsignorDiscrepancyReceiptAttachmentV3$Jpeg } from '../fn/receipts/get-consignor-discrepancy-receipt-attachment-v-3-jpeg';
import { GetConsignorDiscrepancyReceiptAttachmentV3$Jpeg$Params } from '../fn/receipts/get-consignor-discrepancy-receipt-attachment-v-3-jpeg';
import { getConsignorDiscrepancyReceiptAttachmentV3$Pdf } from '../fn/receipts/get-consignor-discrepancy-receipt-attachment-v-3-pdf';
import { GetConsignorDiscrepancyReceiptAttachmentV3$Pdf$Params } from '../fn/receipts/get-consignor-discrepancy-receipt-attachment-v-3-pdf';
import { getConsignorDiscrepancyReceiptAttachmentV3$Png } from '../fn/receipts/get-consignor-discrepancy-receipt-attachment-v-3-png';
import { GetConsignorDiscrepancyReceiptAttachmentV3$Png$Params } from '../fn/receipts/get-consignor-discrepancy-receipt-attachment-v-3-png';
import { getConsignorReceiptsForDeliveryNoteV3 } from '../fn/receipts/get-consignor-receipts-for-delivery-note-v-3';
import { GetConsignorReceiptsForDeliveryNoteV3$Params } from '../fn/receipts/get-consignor-receipts-for-delivery-note-v-3';


/**
 * Receipt management for delivery notes including file retrieval and metadata access
 */
@Injectable({ providedIn: 'root' })
export class ReceiptsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getConsignorDiscrepancyReceiptAttachmentV3()` */
  static readonly GetConsignorDiscrepancyReceiptAttachmentV3Path = '/organization-sites/{organizationSiteKey}/consignor/delivery-notes/{deliveryNoteKey}/receipts/{attachmentKey}/file';

  /**
   * Get a receipts file as consignor.
   *
   * Get a single receipt file for a delivery note as consignor. The bundle must be in status 'closed'.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsignorDiscrepancyReceiptAttachmentV3$Pdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsignorDiscrepancyReceiptAttachmentV3$Pdf$Response(params: GetConsignorDiscrepancyReceiptAttachmentV3$Pdf$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getConsignorDiscrepancyReceiptAttachmentV3$Pdf(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as consignor.
   *
   * Get a single receipt file for a delivery note as consignor. The bundle must be in status 'closed'.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsignorDiscrepancyReceiptAttachmentV3$Pdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsignorDiscrepancyReceiptAttachmentV3$Pdf(params: GetConsignorDiscrepancyReceiptAttachmentV3$Pdf$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getConsignorDiscrepancyReceiptAttachmentV3$Pdf$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /**
   * Get a receipts file as consignor.
   *
   * Get a single receipt file for a delivery note as consignor. The bundle must be in status 'closed'.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsignorDiscrepancyReceiptAttachmentV3$Heic()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsignorDiscrepancyReceiptAttachmentV3$Heic$Response(params: GetConsignorDiscrepancyReceiptAttachmentV3$Heic$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getConsignorDiscrepancyReceiptAttachmentV3$Heic(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as consignor.
   *
   * Get a single receipt file for a delivery note as consignor. The bundle must be in status 'closed'.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsignorDiscrepancyReceiptAttachmentV3$Heic$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsignorDiscrepancyReceiptAttachmentV3$Heic(params: GetConsignorDiscrepancyReceiptAttachmentV3$Heic$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getConsignorDiscrepancyReceiptAttachmentV3$Heic$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /**
   * Get a receipts file as consignor.
   *
   * Get a single receipt file for a delivery note as consignor. The bundle must be in status 'closed'.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsignorDiscrepancyReceiptAttachmentV3$Heif()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsignorDiscrepancyReceiptAttachmentV3$Heif$Response(params: GetConsignorDiscrepancyReceiptAttachmentV3$Heif$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getConsignorDiscrepancyReceiptAttachmentV3$Heif(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as consignor.
   *
   * Get a single receipt file for a delivery note as consignor. The bundle must be in status 'closed'.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsignorDiscrepancyReceiptAttachmentV3$Heif$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsignorDiscrepancyReceiptAttachmentV3$Heif(params: GetConsignorDiscrepancyReceiptAttachmentV3$Heif$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getConsignorDiscrepancyReceiptAttachmentV3$Heif$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /**
   * Get a receipts file as consignor.
   *
   * Get a single receipt file for a delivery note as consignor. The bundle must be in status 'closed'.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsignorDiscrepancyReceiptAttachmentV3$Jpeg()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsignorDiscrepancyReceiptAttachmentV3$Jpeg$Response(params: GetConsignorDiscrepancyReceiptAttachmentV3$Jpeg$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getConsignorDiscrepancyReceiptAttachmentV3$Jpeg(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as consignor.
   *
   * Get a single receipt file for a delivery note as consignor. The bundle must be in status 'closed'.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsignorDiscrepancyReceiptAttachmentV3$Jpeg$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsignorDiscrepancyReceiptAttachmentV3$Jpeg(params: GetConsignorDiscrepancyReceiptAttachmentV3$Jpeg$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getConsignorDiscrepancyReceiptAttachmentV3$Jpeg$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /**
   * Get a receipts file as consignor.
   *
   * Get a single receipt file for a delivery note as consignor. The bundle must be in status 'closed'.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsignorDiscrepancyReceiptAttachmentV3$Png()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsignorDiscrepancyReceiptAttachmentV3$Png$Response(params: GetConsignorDiscrepancyReceiptAttachmentV3$Png$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getConsignorDiscrepancyReceiptAttachmentV3$Png(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as consignor.
   *
   * Get a single receipt file for a delivery note as consignor. The bundle must be in status 'closed'.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsignorDiscrepancyReceiptAttachmentV3$Png$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsignorDiscrepancyReceiptAttachmentV3$Png(params: GetConsignorDiscrepancyReceiptAttachmentV3$Png$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getConsignorDiscrepancyReceiptAttachmentV3$Png$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /** Path part for operation `getConsignorReceiptsForDeliveryNoteV3()` */
  static readonly GetConsignorReceiptsForDeliveryNoteV3Path = '/organization-sites/{organizationSiteKey}/consignor/delivery-notes/{deliveryNoteKey}/receipts';

  /**
   * Get all receipt metadata for a delivery note.
   *
   * Get a list of receipt metadata for a single delivery note as consignor. The bundle must be in status 'closed'.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsignorReceiptsForDeliveryNoteV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsignorReceiptsForDeliveryNoteV3$Response(params: GetConsignorReceiptsForDeliveryNoteV3$Params, context?: HttpContext): Observable<StrictHttpResponse<AttachmentsArrayResponseV3>> {
    return getConsignorReceiptsForDeliveryNoteV3(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all receipt metadata for a delivery note.
   *
   * Get a list of receipt metadata for a single delivery note as consignor. The bundle must be in status 'closed'.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsignorReceiptsForDeliveryNoteV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsignorReceiptsForDeliveryNoteV3(params: GetConsignorReceiptsForDeliveryNoteV3$Params, context?: HttpContext): Observable<AttachmentsArrayResponseV3> {
    return this.getConsignorReceiptsForDeliveryNoteV3$Response(params, context).pipe(
      map((r: StrictHttpResponse<AttachmentsArrayResponseV3>): AttachmentsArrayResponseV3 => r.body)
    );
  }

  /** Path part for operation `getCarrierDiscrepancyReceiptAttachmentV3()` */
  static readonly GetCarrierDiscrepancyReceiptAttachmentV3Path = '/organization-sites/{organizationSiteKey}/carrier/delivery-notes/{deliveryNoteKey}/receipts/{attachmentKey}/file';

  /**
   * Get a receipts file as carrier.
   *
   * Get a single receipt file for a delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCarrierDiscrepancyReceiptAttachmentV3$Pdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDiscrepancyReceiptAttachmentV3$Pdf$Response(params: GetCarrierDiscrepancyReceiptAttachmentV3$Pdf$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getCarrierDiscrepancyReceiptAttachmentV3$Pdf(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as carrier.
   *
   * Get a single receipt file for a delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCarrierDiscrepancyReceiptAttachmentV3$Pdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDiscrepancyReceiptAttachmentV3$Pdf(params: GetCarrierDiscrepancyReceiptAttachmentV3$Pdf$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getCarrierDiscrepancyReceiptAttachmentV3$Pdf$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /**
   * Get a receipts file as carrier.
   *
   * Get a single receipt file for a delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCarrierDiscrepancyReceiptAttachmentV3$Heic()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDiscrepancyReceiptAttachmentV3$Heic$Response(params: GetCarrierDiscrepancyReceiptAttachmentV3$Heic$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getCarrierDiscrepancyReceiptAttachmentV3$Heic(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as carrier.
   *
   * Get a single receipt file for a delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCarrierDiscrepancyReceiptAttachmentV3$Heic$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDiscrepancyReceiptAttachmentV3$Heic(params: GetCarrierDiscrepancyReceiptAttachmentV3$Heic$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getCarrierDiscrepancyReceiptAttachmentV3$Heic$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /**
   * Get a receipts file as carrier.
   *
   * Get a single receipt file for a delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCarrierDiscrepancyReceiptAttachmentV3$Heif()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDiscrepancyReceiptAttachmentV3$Heif$Response(params: GetCarrierDiscrepancyReceiptAttachmentV3$Heif$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getCarrierDiscrepancyReceiptAttachmentV3$Heif(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as carrier.
   *
   * Get a single receipt file for a delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCarrierDiscrepancyReceiptAttachmentV3$Heif$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDiscrepancyReceiptAttachmentV3$Heif(params: GetCarrierDiscrepancyReceiptAttachmentV3$Heif$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getCarrierDiscrepancyReceiptAttachmentV3$Heif$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /**
   * Get a receipts file as carrier.
   *
   * Get a single receipt file for a delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCarrierDiscrepancyReceiptAttachmentV3$Jpeg()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDiscrepancyReceiptAttachmentV3$Jpeg$Response(params: GetCarrierDiscrepancyReceiptAttachmentV3$Jpeg$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getCarrierDiscrepancyReceiptAttachmentV3$Jpeg(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as carrier.
   *
   * Get a single receipt file for a delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCarrierDiscrepancyReceiptAttachmentV3$Jpeg$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDiscrepancyReceiptAttachmentV3$Jpeg(params: GetCarrierDiscrepancyReceiptAttachmentV3$Jpeg$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getCarrierDiscrepancyReceiptAttachmentV3$Jpeg$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /**
   * Get a receipts file as carrier.
   *
   * Get a single receipt file for a delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCarrierDiscrepancyReceiptAttachmentV3$Png()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDiscrepancyReceiptAttachmentV3$Png$Response(params: GetCarrierDiscrepancyReceiptAttachmentV3$Png$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getCarrierDiscrepancyReceiptAttachmentV3$Png(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as carrier.
   *
   * Get a single receipt file for a delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCarrierDiscrepancyReceiptAttachmentV3$Png$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDiscrepancyReceiptAttachmentV3$Png(params: GetCarrierDiscrepancyReceiptAttachmentV3$Png$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getCarrierDiscrepancyReceiptAttachmentV3$Png$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /** Path part for operation `getCarrierReceiptsForDeliveryNoteV3()` */
  static readonly GetCarrierReceiptsForDeliveryNoteV3Path = '/organization-sites/{organizationSiteKey}/carrier/delivery-notes/{deliveryNoteKey}/receipts';

  /**
   * Get all receipt metadata for a delivery note as carrier.
   *
   * Get a list of receipt metadata for a single delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCarrierReceiptsForDeliveryNoteV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierReceiptsForDeliveryNoteV3$Response(params: GetCarrierReceiptsForDeliveryNoteV3$Params, context?: HttpContext): Observable<StrictHttpResponse<AttachmentsArrayResponseV3>> {
    return getCarrierReceiptsForDeliveryNoteV3(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all receipt metadata for a delivery note as carrier.
   *
   * Get a list of receipt metadata for a single delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCarrierReceiptsForDeliveryNoteV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierReceiptsForDeliveryNoteV3(params: GetCarrierReceiptsForDeliveryNoteV3$Params, context?: HttpContext): Observable<AttachmentsArrayResponseV3> {
    return this.getCarrierReceiptsForDeliveryNoteV3$Response(params, context).pipe(
      map((r: StrictHttpResponse<AttachmentsArrayResponseV3>): AttachmentsArrayResponseV3 => r.body)
    );
  }

  /** Path part for operation `getConsigneeDiscrepancyReceiptAttachmentV3()` */
  static readonly GetConsigneeDiscrepancyReceiptAttachmentV3Path = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/receipts/{attachmentKey}/file';

  /**
   * Get a receipts file as consignee.
   *
   * Get a single receipt file for a delivery note as consignee.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeDiscrepancyReceiptAttachmentV3$Pdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDiscrepancyReceiptAttachmentV3$Pdf$Response(params: GetConsigneeDiscrepancyReceiptAttachmentV3$Pdf$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getConsigneeDiscrepancyReceiptAttachmentV3$Pdf(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as consignee.
   *
   * Get a single receipt file for a delivery note as consignee.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeDiscrepancyReceiptAttachmentV3$Pdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDiscrepancyReceiptAttachmentV3$Pdf(params: GetConsigneeDiscrepancyReceiptAttachmentV3$Pdf$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getConsigneeDiscrepancyReceiptAttachmentV3$Pdf$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /**
   * Get a receipts file as consignee.
   *
   * Get a single receipt file for a delivery note as consignee.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeDiscrepancyReceiptAttachmentV3$Heic()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDiscrepancyReceiptAttachmentV3$Heic$Response(params: GetConsigneeDiscrepancyReceiptAttachmentV3$Heic$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getConsigneeDiscrepancyReceiptAttachmentV3$Heic(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as consignee.
   *
   * Get a single receipt file for a delivery note as consignee.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeDiscrepancyReceiptAttachmentV3$Heic$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDiscrepancyReceiptAttachmentV3$Heic(params: GetConsigneeDiscrepancyReceiptAttachmentV3$Heic$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getConsigneeDiscrepancyReceiptAttachmentV3$Heic$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /**
   * Get a receipts file as consignee.
   *
   * Get a single receipt file for a delivery note as consignee.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeDiscrepancyReceiptAttachmentV3$Heif()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDiscrepancyReceiptAttachmentV3$Heif$Response(params: GetConsigneeDiscrepancyReceiptAttachmentV3$Heif$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getConsigneeDiscrepancyReceiptAttachmentV3$Heif(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as consignee.
   *
   * Get a single receipt file for a delivery note as consignee.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeDiscrepancyReceiptAttachmentV3$Heif$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDiscrepancyReceiptAttachmentV3$Heif(params: GetConsigneeDiscrepancyReceiptAttachmentV3$Heif$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getConsigneeDiscrepancyReceiptAttachmentV3$Heif$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /**
   * Get a receipts file as consignee.
   *
   * Get a single receipt file for a delivery note as consignee.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeDiscrepancyReceiptAttachmentV3$Jpeg()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDiscrepancyReceiptAttachmentV3$Jpeg$Response(params: GetConsigneeDiscrepancyReceiptAttachmentV3$Jpeg$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getConsigneeDiscrepancyReceiptAttachmentV3$Jpeg(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as consignee.
   *
   * Get a single receipt file for a delivery note as consignee.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeDiscrepancyReceiptAttachmentV3$Jpeg$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDiscrepancyReceiptAttachmentV3$Jpeg(params: GetConsigneeDiscrepancyReceiptAttachmentV3$Jpeg$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getConsigneeDiscrepancyReceiptAttachmentV3$Jpeg$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /**
   * Get a receipts file as consignee.
   *
   * Get a single receipt file for a delivery note as consignee.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeDiscrepancyReceiptAttachmentV3$Png()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDiscrepancyReceiptAttachmentV3$Png$Response(params: GetConsigneeDiscrepancyReceiptAttachmentV3$Png$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getConsigneeDiscrepancyReceiptAttachmentV3$Png(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as consignee.
   *
   * Get a single receipt file for a delivery note as consignee.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeDiscrepancyReceiptAttachmentV3$Png$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDiscrepancyReceiptAttachmentV3$Png(params: GetConsigneeDiscrepancyReceiptAttachmentV3$Png$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getConsigneeDiscrepancyReceiptAttachmentV3$Png$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /** Path part for operation `getConsigneeReceiptsForDeliveryNoteV3()` */
  static readonly GetConsigneeReceiptsForDeliveryNoteV3Path = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/receipts';

  /**
   * Get all receipt metadata for a delivery note as consignee.
   *
   * Get a list of receipt metadata for a single delivery note as consignee.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeReceiptsForDeliveryNoteV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeReceiptsForDeliveryNoteV3$Response(params: GetConsigneeReceiptsForDeliveryNoteV3$Params, context?: HttpContext): Observable<StrictHttpResponse<AttachmentsArrayResponseV3>> {
    return getConsigneeReceiptsForDeliveryNoteV3(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all receipt metadata for a delivery note as consignee.
   *
   * Get a list of receipt metadata for a single delivery note as consignee.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeReceiptsForDeliveryNoteV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeReceiptsForDeliveryNoteV3(params: GetConsigneeReceiptsForDeliveryNoteV3$Params, context?: HttpContext): Observable<AttachmentsArrayResponseV3> {
    return this.getConsigneeReceiptsForDeliveryNoteV3$Response(params, context).pipe(
      map((r: StrictHttpResponse<AttachmentsArrayResponseV3>): AttachmentsArrayResponseV3 => r.body)
    );
  }

}
